// React imports.
import React, { Component } from "react";

// App imports.


const IntroPage3 = ({ state }) => (
  <div>
    <h2>Measure #1: Benefit Targeting Index</h2>
    <br />

    <p>The <strong>Benefit Targeting Index</strong> tells you whether or not, on average, you are providing larger benefits to higher burden households than to all households receiving LIHEAP bill payment assistance.<span>&nbsp; </span></p>

    <table className="inlineTable" style={{ "width": "60%" }}><tbody>
      <tr>
        <td>
          <i>Benefit Targeting Index</i> =
        </td>
        <td align="center">
          <div style={{ "textAlign": "center" }}>
            <i>Mean Benefit (High Burden Households)</i>
            <hr />
            <i>Mean Benefit (All LIHEAP Households)</i>
          </div>
        </td>
        <td>
          × 100
        </td>
      </tr>
    </tbody></table>
    <br />
    <div className="takeaways" >
      <p><strong>Key Takeaways:</strong></p>
      <ul>
        <li>The higher the <strong>Benefit Targeting Index</strong> value, the better you are doing at targeting larger benefits to households with higher energy burdens.
          <br /><br />
        </li>
        <li>Having a high <strong>Benefit Targeting Index</strong> value is important because the LIHEAP Statute requires that grantees furnish the highest level of assistance to households with the lowest incomes and highest energy costs or needs. </li>
      </ul>
    </div>

    <br />
    <p>Please click <em>Next </em>to continue.&nbsp;</p>
  </div>
);

export default IntroPage3;
